import React from 'react';
import { Card, CardContent } from '../../components/ui/card';

const AdminCustomersTab = ({ customers }) => {
  return (
    <div data-testid="admin-customers-tab">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '700' }}>All Customers</h2>
        <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>
          Total: {customers.length} customers
        </div>
      </div>

      <Card>
        <CardContent style={{ padding: '0', overflowX: 'auto' }}>
          <div style={{ minWidth: '700px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead style={{ backgroundColor: '#f9fafb', borderBottom: '2px solid #e5e7eb' }}>
                <tr>
                  <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600', fontSize: '0.75rem', color: '#374151' }}>
                    Customer
                  </th>
                  <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600', fontSize: '0.75rem', color: '#374151' }}>
                    Email
                  </th>
                  <th style={{ padding: '0.75rem', textAlign: 'center', fontWeight: '600', fontSize: '0.75rem', color: '#374151' }}>
                    Total Bookings
                  </th>
                  <th style={{ padding: '0.75rem', textAlign: 'center', fontWeight: '600', fontSize: '0.75rem', color: '#374151' }}>
                    Total Spent
                  </th>
                  <th style={{ padding: '0.75rem', textAlign: 'center', fontWeight: '600', fontSize: '0.75rem', color: '#374151' }}>
                    Last Booking
                  </th>
                </tr>
              </thead>
              <tbody>
                {customers && customers.map((customer, idx) => (
                  <tr key={customer.email || `customer-${idx}`} style={{ borderBottom: '1px solid #e5e7eb' }}>
                    <td style={{ padding: '0.75rem', fontWeight: '600', fontSize: '0.875rem' }}>
                      {customer.name || 'N/A'}
                    </td>
                    <td style={{ padding: '0.75rem', color: '#6b7280', fontSize: '0.75rem' }}>
                      {customer.email}
                    </td>
                    <td style={{ padding: '0.75rem', textAlign: 'center', fontWeight: '600', fontSize: '0.875rem' }}>
                      {customer.total_bookings}
                    </td>
                    <td style={{ padding: '0.75rem', textAlign: 'center', fontWeight: '700', color: '#10b981', fontSize: '0.875rem' }}>
                      ${customer.total_spent?.toFixed(2)}
                    </td>
                    <td style={{ padding: '0.75rem', textAlign: 'center', fontSize: '0.75rem', color: '#6b7280' }}>
                      {customer.last_booking ? new Date(customer.last_booking).toLocaleDateString() : 'N/A'}
                    </td>
                  </tr>
                ))}
                {customers.length === 0 && (
                  <tr>
                    <td colSpan="5" style={{ padding: '2rem', textAlign: 'center', color: '#9ca3af' }}>
                      No customers yet
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminCustomersTab;
